<script lang="ts">
  import AUButtonIcon from "component_library/components/svelte/ui/AUButtonIcon.svelte"
  import { leadFlowIcon } from "conversion_flows/types/leadFlowIcons"
  import { getContext } from "svelte"
  import IntegrationTypes from "website_script/constants/IntegrationTypes"
  import { getFlowsContext } from "website_script/contexts/flows"
  import {
    DEFAULT_CONTACT_WIDGET_POSITION,
    getPositionStyle,
  } from "website_script/lib/widgetPosition"
  import { Environment } from "website_script/types/environment"
  import type { Settings } from "website_script/types/settings"

  const { enableContactWidget, contactWidgetConfig } =
    getContext<Settings>("settings")
  const { trackFunction } = getContext<Environment>("environment")
  const { triggerFlow } = getFlowsContext()

  const positionStyle = getPositionStyle(
    contactWidgetConfig.position || DEFAULT_CONTACT_WIDGET_POSITION
  )

  trackFunction({
    entity: "contact-widget",
    action: "displayed",
    flow: contactWidgetConfig.buttons.map((b) => b.flow_type),
    type: "displayed_cta",
  })
</script>

{#if enableContactWidget}
  <div
    class="au-contact-widget"
    data-testid="au-contact-widget"
    style={positionStyle}
  >
    {#each contactWidgetConfig.buttons as buttonConfig}
      <AUButtonIcon
        sroText={buttonConfig.text}
        icon={leadFlowIcon(buttonConfig.icon)}
        onClick={() =>
          triggerFlow(buttonConfig, IntegrationTypes.CONTACT_WIDGET)}
        size="md"
      />
    {/each}
  </div>
{/if}

<style>
  .au-contact-widget {
    z-index: var(--au-z-index-widget);
    position: fixed;
    display: flex;
    flex-direction: column;
    gap: var(--au-spacing-xs);
    border-radius: var(--au-tappable-size);
    background-color: var(--au-background-default);
    box-shadow: var(--au-box-shadow-strong);
    padding: var(--au-spacing-xs);
  }
</style>
